import {
  FiBookOpen,
  FiCalendar,
  FiFile,
  FiFileText,
  FiMap,
  FiSearch,
  FiShoppingBag,
  FiUsers,
} from "react-icons/fi";
import { FaNewspaper } from "react-icons/fa";
import { HiOfficeBuilding } from "react-icons/hi";

export const RECHERCHE_PAGE = {
  title: "Recherche",
  eyebrow: "Trouver rapidement",
  description:
    "Recherchez dans les pages, actualités, événements, services municipaux et contenus publics de la commune.",
  heroImageUrl:
    "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Recherche" },
  ],
};

export const SEARCH_MIN_LENGTH = 2;
export const SEARCH_DEBOUNCE_MS = 450;
export const SEARCH_LIMIT = 30;

export const SEARCH_SECTIONS = [
  {
    key: "pages",
    label: "Pages",
    singular: "Page",
    emptyLabel: "Aucune page trouvée.",
    icon: FiFileText,
    badgeClass:
      "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-sky-300",
  },
  {
    key: "news",
    label: "Actualités",
    singular: "Actualité",
    emptyLabel: "Aucune actualité trouvée.",
    icon: FaNewspaper,
    badgeClass:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
  },
  {
    key: "events",
    label: "Événements",
    singular: "Événement",
    emptyLabel: "Aucun événement trouvé.",
    icon: FiCalendar,
    badgeClass:
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
  },
  {
    key: "services",
    label: "Services municipaux",
    singular: "Service",
    emptyLabel: "Aucun service municipal trouvé.",
    icon: HiOfficeBuilding,
    badgeClass:
      "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300",
  },
  {
    key: "associations",
    label: "Associations",
    singular: "Association",
    emptyLabel: "Aucune association trouvée.",
    icon: FiUsers,
    badgeClass:
      "border-teal-200 bg-teal-50 text-teal-700 dark:border-teal-500/20 dark:bg-teal-500/10 dark:text-teal-300",
  },
  {
    key: "commerces",
    label: "Commerces",
    singular: "Commerce",
    emptyLabel: "Aucun commerce trouvé.",
    icon: FiShoppingBag,
    badgeClass:
      "border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300",
  },
  {
    key: "documents",
    label: "Documents",
    singular: "Document",
    emptyLabel: "Aucun document trouvé.",
    icon: FiFile,
    badgeClass:
      "border-red-200 bg-red-50 text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300",
  },
  {
    key: "publications",
    label: "Publications",
    singular: "Publication",
    emptyLabel: "Aucune publication trouvée.",
    icon: FiBookOpen,
    badgeClass:
      "border-violet-200 bg-violet-50 text-violet-700 dark:border-violet-500/20 dark:bg-violet-500/10 dark:text-violet-300",
  },
  {
    key: "projets",
    label: "Projets",
    singular: "Projet",
    emptyLabel: "Aucun projet trouvé.",
    icon: FiMap,
    badgeClass:
      "border-cyan-200 bg-cyan-50 text-cyan-700 dark:border-cyan-500/20 dark:bg-cyan-500/10 dark:text-cyan-300",
  },
];

export const DEFAULT_SEARCH_SECTION = {
  key: "autres",
  label: "Autres résultats",
  singular: "Résultat",
  emptyLabel: "Aucun résultat trouvé.",
  icon: FiSearch,
  badgeClass:
    "border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300",
};